var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { keyframes } from 'styled-components';
var animations = {
    moveToLeft: {
        keyframes: keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      from { }\n      to { transform: translateX(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { transform: translateX(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveFromLeft: {
        keyframes: keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      from {  transform: translateX(-100%) rotateZ(0.01deg); }\n    "], ["\n      from {  transform: translateX(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveToRight: {
        keyframes: keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      from { }\n      to { transform: translateX(100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { transform: translateX(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveFromRight: {
        keyframes: keyframes(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      from { transform: translateX(100%) rotateZ(0.01deg); }\n    "], ["\n      from { transform: translateX(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveToTop: {
        keyframes: keyframes(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      from { }\n      to { transform: translateY(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { transform: translateY(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveFromTop: {
        keyframes: keyframes(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      from { transform: translateY(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { transform: translateY(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveToBottom: {
        keyframes: keyframes(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      from { }\n      to { transform: translateY(100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { transform: translateY(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveFromBottom: {
        keyframes: keyframes(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      from { transform: translateY(100%) rotateZ(0.01deg); }\n    "], ["\n      from { transform: translateY(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    fade: {
        keyframes: keyframes(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; }\n    "], ["\n      from { }\n      to { opacity: 0.3; }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveToLeftFade: {
        keyframes: keyframes(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateX(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateX(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    moveFromLeftFade: {
        keyframes: keyframes(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      from { opacity: 0.3;  transform: translateX(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { opacity: 0.3;  transform: translateX(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    moveToRightFade: {
        keyframes: keyframes(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3;  transform: translateX(100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3;  transform: translateX(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    moveFromRightFade: {
        keyframes: keyframes(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateX(100%) rotateZ(0.01deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateX(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    moveToTopFade: {
        keyframes: keyframes(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateY(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateY(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 600,
        timing: 'ease',
        fill: 'both'
    },
    moveFromTopFade: {
        keyframes: keyframes(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateY(-100%) rotateZ(0.01deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateY(-100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    moveToBottomFade: {
        keyframes: keyframes(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3;  transform: translateY(100%) rotateZ(0.01deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3;  transform: translateY(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    moveFromBottomFade: {
        keyframes: keyframes(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateY(100%) rotateZ(0.01deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateY(100%) rotateZ(0.01deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    scaleDown: {
        keyframes: keyframes(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: scale(0.8); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: scale(0.8); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    scaleUp: {
        keyframes: keyframes(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n\t    from { opacity: 0;  transform: scale(0.8); }\n    "], ["\n\t    from { opacity: 0;  transform: scale(0.8); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both'
    },
    scaleUpDown: {
        keyframes: keyframes(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      from { opacity: 0; transform: scale(1.2); }\n    "], ["\n      from { opacity: 0; transform: scale(1.2); }\n    "]))),
        duration: 500,
        timing: 'ease',
        fill: 'both'
    },
    scaleDownUp: {
        keyframes: keyframes(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n\t    from { }\n\t    to { opacity: 0; transform: scale(1.2); }\n    "], ["\n\t    from { }\n\t    to { opacity: 0; transform: scale(1.2); }\n    "]))),
        duration: 500,
        timing: 'ease',
        fill: 'both'
    },
    scaleDownCenter: {
        keyframes: keyframes(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: scale(0.7); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: scale(0.7); }\n    "]))),
        duration: 400,
        timing: 'ease',
        fill: 'both'
    },
    scaleUpCenter: {
        keyframes: keyframes(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n      from { opacity: 0;  transform: scale(0.7); }\n    "], ["\n      from { opacity: 0;  transform: scale(0.7); }\n    "]))),
        duration: 400,
        timing: 'ease',
        fill: 'both'
    },
    rotateRightSideFirst: {
        keyframes: keyframes(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n      0% { }\n      40% { transform: rotateY(15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "], ["\n      0% { }\n      40% { transform: rotateY(15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]))),
        duration: 800,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateLeftSideFirst: {
        keyframes: keyframes(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n      0% { }\n      40% { transform: rotateY(-15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "], ["\n      0% { }\n      40% { transform: rotateY(-15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]))),
        duration: 800,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateTopSideFirst: {
        keyframes: keyframes(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      0% { }\n      40% { transform: rotateX(15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "], ["\n      0% { }\n      40% { transform: rotateX(15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]))),
        duration: 800,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateBottomSideFirst: {
        keyframes: keyframes(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n      0% { }\n      40% { transform: rotateX(-15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% {transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "], ["\n      0% { }\n      40% { transform: rotateX(-15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% {transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]))),
        duration: 800,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 50%'
    },
    flipOutRight: {
        keyframes: keyframes(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n      from { }\n      to { transform: translateZ(-1000px) rotateY(90deg); opacity: 0.2; }\n    "], ["\n      from { }\n      to { transform: translateZ(-1000px) rotateY(90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 50%'
    },
    flipInLeft: {
        keyframes: keyframes(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n      from { transform: translateZ(-1000px) rotateY(-90deg); opacity: 0.2; }\n    "], ["\n      from { transform: translateZ(-1000px) rotateY(-90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-out',
        fill: 'both',
        origin: '50% 50%'
    },
    flipOutLeft: {
        keyframes: keyframes(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n      from { }\n      to { transform: translateZ(-1000px) rotateY(-90deg); opacity: 0.2; }\n    "], ["\n      from { }\n      to { transform: translateZ(-1000px) rotateY(-90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 50%'
    },
    flipInRight: {
        keyframes: keyframes(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n      from { transform: translateZ(-1000px) rotateY(90deg); opacity: 0.2; }\n    "], ["\n      from { transform: translateZ(-1000px) rotateY(90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-out',
        fill: 'both',
        origin: '50% 50%'
    },
    flipOutTop: {
        keyframes: keyframes(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n      from { }\n      to { transform: translateZ(-1000px) rotateX(90deg); opacity: 0.2; }\n    "], ["\n      from { }\n      to { transform: translateZ(-1000px) rotateX(90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 50%'
    },
    flipInBottom: {
        keyframes: keyframes(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n      from { transform: translateZ(-1000px) rotateX(-90deg); opacity: 0.2; }\n    "], ["\n      from { transform: translateZ(-1000px) rotateX(-90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-out',
        fill: 'both',
        origin: '50% 50%'
    },
    flipOutBottom: {
        keyframes: keyframes(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n      from { }\n      to { transform: translateZ(-1000px) rotateX(-90deg); opacity: 0.2; }\n    "], ["\n      from { }\n      to { transform: translateZ(-1000px) rotateX(-90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 50%'
    },
    flipInTop: {
        keyframes: keyframes(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n      from { transform: translateZ(-1000px) rotateX(90deg); opacity: 0.2; }\n    "], ["\n      from { transform: translateZ(-1000px) rotateX(90deg); opacity: 0.2; }\n    "]))),
        duration: 500,
        timing: 'ease-out',
        fill: 'both',
        origin: '50% 50%'
    },
    rotateFall: {
        keyframes: keyframes(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n      0% { transform: rotateZ(0deg); }\n      20% { transform: rotateZ(10deg); animation-timing-function: ease-out; }\n      40% { transform: rotateZ(17deg); }\n      60% { transform: rotateZ(16deg); }\n      100% { transform: translateY(100%) rotateZ(17deg); }\n    "], ["\n      0% { transform: rotateZ(0deg); }\n      20% { transform: rotateZ(10deg); animation-timing-function: ease-out; }\n      40% { transform: rotateZ(17deg); }\n      60% { transform: rotateZ(16deg); }\n      100% { transform: translateY(100%) rotateZ(17deg); }\n    "]))),
        duration: 1000,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 0%'
    },
    rotateOutNewspaper: {
        keyframes: keyframes(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n      from { }\n      to { transform: translateZ(-3000px) rotateZ(360deg); opacity: 0; }\n    "], ["\n      from { }\n      to { transform: translateZ(-3000px) rotateZ(360deg); opacity: 0; }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 50%'
    },
    rotateInNewspaper: {
        keyframes: keyframes(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n      from { transform: translateZ(-3000px) rotateZ(-360deg); opacity: 0; }\n    "], ["\n      from { transform: translateZ(-3000px) rotateZ(-360deg); opacity: 0; }\n    "]))),
        duration: 500,
        timing: 'ease-out',
        fill: 'both',
        origin: '50% 50%'
    },
    rotatePushLeft: {
        keyframes: keyframes(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: rotateY(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: rotateY(90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotatePushRight: {
        keyframes: keyframes(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: rotateY(-90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: rotateY(-90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotatePushTop: {
        keyframes: keyframes(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: rotateX(-90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: rotateX(-90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotatePushBottom: {
        keyframes: keyframes(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: rotateX(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: rotateX(90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotatePullRight: {
        keyframes: keyframes(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n      from { opacity: 0; transform: rotateY(-90deg); }\n    "], ["\n      from { opacity: 0; transform: rotateY(-90deg); }\n    "]))),
        duration: 500,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotatePullLeft: {
        keyframes: keyframes(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n      from { opacity: 0; transform: rotateY(90deg); }\n    "], ["\n      from { opacity: 0; transform: rotateY(90deg); }\n    "]))),
        duration: 500,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotatePullTop: {
        keyframes: keyframes(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n      from { opacity: 0; transform: rotateX(-90deg); }\n    "], ["\n      from { opacity: 0; transform: rotateX(-90deg); }\n    "]))),
        duration: 500,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotatePullBottom: {
        keyframes: keyframes(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n      from { opacity: 0; transform: rotateX(90deg); }\n    "], ["\n      from { opacity: 0; transform: rotateX(90deg); }\n    "]))),
        duration: 500,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateFoldRight: {
        keyframes: keyframes(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: translateX(100%) rotateY(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: translateX(100%) rotateY(90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateFoldLeft: {
        keyframes: keyframes(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: translateX(-100%) rotateY(-90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: translateX(-100%) rotateY(-90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateFoldTop: {
        keyframes: keyframes(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: translateY(-100%) rotateX(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: translateY(-100%) rotateX(90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateFoldBottom: {
        keyframes: keyframes(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: translateY(100%) rotateX(-90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: translateY(100%) rotateX(-90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateUnfoldLeft: {
        keyframes: keyframes(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n      from { opacity: 0; transform: translateX(-100%) rotateY(-90deg); }\n    "], ["\n      from { opacity: 0; transform: translateX(-100%) rotateY(-90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateUnfoldRight: {
        keyframes: keyframes(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n      from { opacity: 0;  transform: translateX(100%) rotateY(90deg); }\n    "], ["\n      from { opacity: 0;  transform: translateX(100%) rotateY(90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateUnfoldTop: {
        keyframes: keyframes(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n      from { opacity: 0; transform: translateY(-100%) rotateX(90deg); }\n    "], ["\n      from { opacity: 0; transform: translateY(-100%) rotateX(90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateUnfoldBottom: {
        keyframes: keyframes(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n      from { opacity: 0; transform: translateY(100%) rotateX(-90deg); }\n    "], ["\n      from { opacity: 0; transform: translateY(100%) rotateX(-90deg); }\n    "]))),
        duration: 700,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateRoomLeftOut: {
        keyframes: keyframes(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateX(-100%) rotateY(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateX(-100%) rotateY(90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateRoomLeftIn: {
        keyframes: keyframes(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateX(100%) rotateY(-90deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateX(100%) rotateY(-90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateRoomRightOut: {
        keyframes: keyframes(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateX(100%) rotateY(-90deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateX(100%) rotateY(-90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateRoomRightIn: {
        keyframes: keyframes(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateX(-100%) rotateY(90deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateX(-100%) rotateY(90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateRoomTopOut: {
        keyframes: keyframes(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateY(-100%) rotateX(-90deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateY(-100%) rotateX(-90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateRoomTopIn: {
        keyframes: keyframes(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateY(100%) rotateX(90deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateY(100%) rotateX(90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateRoomBottomOut: {
        keyframes: keyframes(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateY(100%) rotateX(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateY(100%) rotateX(90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateRoomBottomIn: {
        keyframes: keyframes(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateY(-100%) rotateX(-90deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateY(-100%) rotateX(-90deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateCubeLeftOut: {
        keyframes: keyframes(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateX(-50%) translateZ(-200px) rotateY(-45deg); }\n      100% { opacity: 0.3; transform: translateX(-100%) rotateY(-90deg); }\n    "], ["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateX(-50%) translateZ(-200px) rotateY(-45deg); }\n      100% { opacity: 0.3; transform: translateX(-100%) rotateY(-90deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateCubeLeftIn: {
        keyframes: keyframes(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n      0% { opacity: 0.3; transform: translateX(100%) rotateY(90deg); }\n      50% { animation-timing-function: ease-out; transform: translateX(50%) translateZ(-200px) rotateY(45deg); }\n    "], ["\n      0% { opacity: 0.3; transform: translateX(100%) rotateY(90deg); }\n      50% { animation-timing-function: ease-out; transform: translateX(50%) translateZ(-200px) rotateY(45deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateCubeRightOut: {
        keyframes: keyframes(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateX(50%) translateZ(-200px) rotateY(45deg); }\n      100% { opacity: 0.3; transform: translateX(100%) rotateY(90deg); }\n    "], ["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateX(50%) translateZ(-200px) rotateY(45deg); }\n      100% { opacity: 0.3; transform: translateX(100%) rotateY(90deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateCubeRightIn: {
        keyframes: keyframes(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n      0% { opacity: 0.3; transform: translateX(-100%) rotateY(-90deg); }\n      50% { animation-timing-function: ease-out; transform: translateX(-50%) translateZ(-200px) rotateY(-45deg); }\n    "], ["\n      0% { opacity: 0.3; transform: translateX(-100%) rotateY(-90deg); }\n      50% { animation-timing-function: ease-out; transform: translateX(-50%) translateZ(-200px) rotateY(-45deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateCubeTopOut: {
        keyframes: keyframes(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n      0% {}\n      50% { animation-timing-function: ease-out; transform: translateY(-50%) translateZ(-200px) rotateX(45deg); }\n      100% { opacity: 0.3; transform: translateY(-100%) rotateX(90deg); }\n    "], ["\n      0% {}\n      50% { animation-timing-function: ease-out; transform: translateY(-50%) translateZ(-200px) rotateX(45deg); }\n      100% { opacity: 0.3; transform: translateY(-100%) rotateX(90deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateCubeTopIn: {
        keyframes: keyframes(templateObject_68 || (templateObject_68 = __makeTemplateObject(["\n      0% { opacity: 0.3; transform: translateY(100%) rotateX(-90deg); }\n      50% { animation-timing-function: ease-out; transform: translateY(50%) translateZ(-200px) rotateX(-45deg); }\n    "], ["\n      0% { opacity: 0.3; transform: translateY(100%) rotateX(-90deg); }\n      50% { animation-timing-function: ease-out; transform: translateY(50%) translateZ(-200px) rotateX(-45deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateCubeBottomOut: {
        keyframes: keyframes(templateObject_69 || (templateObject_69 = __makeTemplateObject(["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateY(50%) translateZ(-200px) rotateX(-45deg); }\n      100% { opacity: 0.3; -webkit-transform: translateY(100%) rotateX(-90deg); transform: translateY(100%) rotateX(-90deg); }\n    "], ["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateY(50%) translateZ(-200px) rotateX(-45deg); }\n      100% { opacity: 0.3; -webkit-transform: translateY(100%) rotateX(-90deg); transform: translateY(100%) rotateX(-90deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateCubeBottomIn: {
        keyframes: keyframes(templateObject_70 || (templateObject_70 = __makeTemplateObject(["\n      0% { opacity: 0.3; -webkit-transform: translateY(-100%) rotateX(90deg); transform: translateY(-100%) rotateX(90deg); }\n      50% { animation-timing-function: ease-out; transform: translateY(-50%) translateZ(-200px) rotateX(45deg); }\n    "], ["\n      0% { opacity: 0.3; -webkit-transform: translateY(-100%) rotateX(90deg); transform: translateY(-100%) rotateX(90deg); }\n      50% { animation-timing-function: ease-out; transform: translateY(-50%) translateZ(-200px) rotateX(45deg); }\n    "]))),
        duration: 600,
        timing: 'ease-in',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateCarouselLeftOut: {
        keyframes: keyframes(templateObject_71 || (templateObject_71 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateX(-150%) scale(0.4) rotateY(-65deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateX(-150%) scale(0.4) rotateY(-65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateCarouselLeftIn: {
        keyframes: keyframes(templateObject_72 || (templateObject_72 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateX(200%) scale(0.4) rotateY(65deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateX(200%) scale(0.4) rotateY(65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateCarouselRightOut: {
        keyframes: keyframes(templateObject_73 || (templateObject_73 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateX(200%) scale(0.4) rotateY(65deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateX(200%) scale(0.4) rotateY(65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '0% 50%'
    },
    rotateCarouselRightIn: {
        keyframes: keyframes(templateObject_74 || (templateObject_74 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateX(-200%) scale(0.4) rotateY(-65deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateX(-200%) scale(0.4) rotateY(-65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '100% 50%'
    },
    rotateCarouselTopOut: {
        keyframes: keyframes(templateObject_75 || (templateObject_75 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateY(-200%) scale(0.4) rotateX(65deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateY(-200%) scale(0.4) rotateX(65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateCarouselTopIn: {
        keyframes: keyframes(templateObject_76 || (templateObject_76 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateY(200%) scale(0.4) rotateX(-65deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateY(200%) scale(0.4) rotateX(-65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateCarouselBottomOut: {
        keyframes: keyframes(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0.3; transform: translateY(200%) scale(0.4) rotateX(-65deg); }\n    "], ["\n      from { }\n      to { opacity: 0.3; transform: translateY(200%) scale(0.4) rotateX(-65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 0%'
    },
    rotateCarouselBottomIn: {
        keyframes: keyframes(templateObject_78 || (templateObject_78 = __makeTemplateObject(["\n      from { opacity: 0.3; transform: translateY(-200%) scale(0.4) rotateX(65deg); }\n    "], ["\n      from { opacity: 0.3; transform: translateY(-200%) scale(0.4) rotateX(65deg); }\n    "]))),
        duration: 800,
        timing: 'ease',
        fill: 'both',
        origin: '50% 100%'
    },
    rotateSidesOut: {
        keyframes: keyframes(templateObject_79 || (templateObject_79 = __makeTemplateObject(["\n      from { }\n      to { opacity: 0; transform: translateZ(-500px) rotateY(90deg); }\n    "], ["\n      from { }\n      to { opacity: 0; transform: translateZ(-500px) rotateY(90deg); }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '-50% 50%'
    },
    rotateSidesIn: {
        keyframes: keyframes(templateObject_80 || (templateObject_80 = __makeTemplateObject(["\n      from { opacity: 0; transform: translateZ(-500px) rotateY(-90deg); }\n    "], ["\n      from { opacity: 0; transform: translateZ(-500px) rotateY(-90deg); }\n    "]))),
        duration: 500,
        timing: 'ease-in',
        fill: 'both',
        origin: '150% 50%'
    },
    rotateSlideOut: {
        keyframes: keyframes(templateObject_81 || (templateObject_81 = __makeTemplateObject(["\n      0% { }\n      25% { opacity: 0.5; transform: translateZ(-500px); }\n      75% { opacity: 0.5; transform: translateZ(-500px) translateX(-200%); }\n      100% { opacity: 0.5; transform: translateZ(-500px) translateX(-200%); }\n    "], ["\n      0% { }\n      25% { opacity: 0.5; transform: translateZ(-500px); }\n      75% { opacity: 0.5; transform: translateZ(-500px) translateX(-200%); }\n      100% { opacity: 0.5; transform: translateZ(-500px) translateX(-200%); }\n    "]))),
        duration: 1000,
        timing: 'ease',
        fill: 'both'
    },
    rotateSlideIn: {
        keyframes: keyframes(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n      0%, 25% { opacity: 0.5; transform: translateZ(-500px) translateX(200%); }\n      75% { opacity: 0.5; transform: translateZ(-500px); }\n      100% { opacity: 1; transform: translateZ(0) translateX(0); }\n    "], ["\n      0%, 25% { opacity: 0.5; transform: translateZ(-500px) translateX(200%); }\n      75% { opacity: 0.5; transform: translateZ(-500px); }\n      100% { opacity: 1; transform: translateZ(0) translateX(0); }\n    "]))),
        duration: 1000,
        timing: 'ease',
        fill: 'both'
    }
};
export { animations };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82;
